'use strict';

var jsxRuntime = require('react/jsx-runtime');
require('../../DataDisplays/Avatar/Avatar.js');
require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
require('../../DataDisplays/Label/Label.js');
var ProductIcon = require('../../DataDisplays/ProductIcon/ProductIcon.js');
require('../../DataDisplays/SystemIcon/Icons/Medium/MediumBell.js');
var Divider = require('../../DataDisplays/Divider/Divider.js');
var MessageBox_parts = require('./MessageBox.parts.js');

/**
 * 아이콘, 제목, 설명, 외부 링크 등을 포함할 수 있는 메시지 박스 컴포넌트입니다.
 *
 * @component
 * @param {Object} props - 컴포넌트 프로퍼티
 * @param {ProductIconName} [props.icon] - 메시지 박스 상단에 표시될 아이콘
 * @param {string} [props.title] - 메시지 박스의 제목
 * @param {string} [props.description] - 메시지 박스의 설명 텍스트
 * @param {ExternalLink[]} [props.links] - 메시지 박스 하단에 표시될 외부 링크 목록
 * @param {React.ReactNode} [props.children] - 메시지 박스 내부에 표시될 자식 컴포넌트
 *
 * @example
 * // 기본 사용 예시
 * <MessageBox
 *   icon="info"
 *   title="알림 메시지"
 *   description="중요한 안내사항입니다."
 * />
 *
 * // 외부 링크가 포함된 예시
 * <MessageBox
 *   icon="warning"
 *   title="주의사항"
 *   description="다음 링크를 확인해주세요."
 *   links={[
 *     {
 *       text: "자세히 보기",
 *       href: "https://example.com",
 *       external: true
 *     }
 *   ]}
 * >
 *   <CustomContent />
 * </MessageBox>
 */ const MessageBox = ({ icon, title, description, children, links })=>{
    return jsxRuntime.jsxs(Box, {
        className: "box-border flex h-auto flex-col rounded-3xl border border-w-gray-200",
        "data-testid": "design-system-message-box--container",
        children: [
            jsxRuntime.jsxs(Box, {
                className: "flex h-auto flex-col gap-4 p-6",
                children: [
                    icon && jsxRuntime.jsx(Box, {
                        className: "size-10 flex-shrink-0",
                        children: jsxRuntime.jsx(ProductIcon, {
                            name: icon,
                            size: "medium"
                        })
                    }),
                    jsxRuntime.jsxs(Box, {
                        className: "flex h-auto flex-col gap-1.5",
                        children: [
                            jsxRuntime.jsx(Typography, {
                                variant: "subTitle2",
                                className: "whitespace-pre-line font-medium text-w-gray-900",
                                "data-testid": "design-system-message-box--title",
                                children: title
                            }),
                            description && jsxRuntime.jsx(Typography, {
                                variant: "body1",
                                className: "whitespace-pre-line font-normal text-w-gray-600",
                                "data-testid": "design-system-message-box--description",
                                children: description
                            }),
                            children
                        ]
                    })
                ]
            }),
            links && links.length > 0 && jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [
                    jsxRuntime.jsx(Divider, {}),
                    jsxRuntime.jsx(MessageBox_parts.ExternalLinks, {
                        links: links
                    })
                ]
            })
        ]
    });
};

module.exports = MessageBox;
